<template>
    <div class="banner-box">
        <div v-swiper:mySwiper="swiperOption">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="item in list" :key="item.id">
                    <a :href="`${item.imgLink ? item.imgLink : 'javascript: void(0)'}`" target="_blank">
                        <img :src="item.imgUrl">
                    </a>
                </div>
            </div>
            <div class="swiper-pagination"></div>
        </div>
    </div>
</template>

<script>
    import 'swiper/css/swiper.css'
    import { directive } from 'vue-awesome-swiper'

    export default {
        name: 'TravelNotesSwiper',
        directives: {
            swiper: directive,
        },
        props: {
            list: {
                type: Array,
                default: function () {
                    return []
                },
            },
        },
        data () {
            return {
                swiperOption: {
                    loop: true,
                    pagination: {
                        el: '.swiper-pagination',
                    },
                },
            }
        },
    }
</script>

<style lang="less" scoped>
    .banner-box {
        width: 100%;
        a {
            display: block;
            width: 100%;
        }
    }
    .swiper-container {
        width: 100%;
        .swiper-wrapper {
            width: 100%;
            .swiper-slide {
                width: 100%;
                img {
                    width: 100%;
                }
            }
        }
    }
</style>
